import {
  NEWS_DESCRIPTION_MAX,
  NEWS_PORTAL_TYPES,
  NEWS_TITLE_MAX,
} from 'volto-ministerio-publico-federal/constants';

/**
 * Notícia com título ou descrição acima do limite: o formulário não pode ser
 * salvo (o backend também recusa — `subscribers/limite_titulo_descricao.py`).
 */
export const excedeLimitesNoticia = (
  type: string | undefined,
  formData: { title?: unknown; description?: unknown } | undefined,
): boolean => {
  if (!type || !NEWS_PORTAL_TYPES.includes(type) || !formData) return false;
  const { title, description } = formData;
  return (
    (typeof title === 'string' && title.length > NEWS_TITLE_MAX) ||
    (typeof description === 'string' &&
      description.length > NEWS_DESCRIPTION_MAX)
  );
};
